export default {
	'.*FINANCE_DEFAULT.*': 'Finance',
	'.*PROMOTIONS_LISTING_PARTS.*': 'Parts Specials'
};
